export default __webpack_public_path__ + "static/media/jz-logo30.6c4513b7.png";